import PolicyPage from "./Default/PolicyPage";

export default PolicyPage;
